import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gaqv5mfhp3: FaireBrandEntity = {
  token: "b_gaqv5mfhp3",
  type: "brand",
  name: "G & J Avenue",
  avatarUrl:
    "https://cdn.faire.com/fastly/643af045a3d3b80ddab5657af80b7254fe575d97f147c721e8106e70ab5050ce.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/916663d02ee0ffcda8f85a2759cdd09ba7803a24dfaa49288547a6f2d079395b.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/643af045a3d3b80ddab5657af80b7254fe575d97f147c721e8106e70ab5050ce.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/916663d02ee0ffcda8f85a2759cdd09ba7803a24dfaa49288547a6f2d079395b.webp",
  location: "sherman oaks, CA, USA",
  minimumOrderDollars: 172,
  rating: 4.5,
  reviewCount: 6,
  isInsider: true,
  description:
    "G+ J AVENUE is a woman owned and operated shop, here to help create customized gifts for all your life events. From Engagements to Baby Shower, our personalized goodies are the perfect way to say congratulations and show your love. All our items are made in house & we source all of our materials carefully to ensure everything has been ethically made and is of the highest quality.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.298Z",
    importedBy: "entity-db-cli",
  },
};
